var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -0.5 26 26",
    shapeRendering: "crispEdges",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M14 2h8m-8 1h8M12 4h2m6 0h2M12 5h2m6 0h2M10 6h2m8 0h2M10 7h2m8 0h2M8 8h2m10 0h2M8 9h2m10 0h2M2 10h2m2 0h2m10 0h2M2 11h2m2 0h2m10 0h2M0 12h2m2 0h2m10 0h2M0 13h2m2 0h2m10 0h2M2 14h2m10 0h2M2 15h2m10 0h2M2 16h2m8 0h2M2 17h2m8 0h2M0 18h2m8 0h2M0 19h2m8 0h2M0 20h2m4 0h4m2 0h2M0 21h2m4 0h4m2 0h2M0 22h8m2 0h2M0 23h8m2 0h2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#ff574d",
    d: "M14 4h2m-2 1h2m-4 1h2m-2 1h2m-4 1h2m-2 1h2m-4 1h2m-2 1h2m-4 1h2m-2 1h2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#793431",
    d: "M16 4h2m-2 1h2m-4 1h2m-2 1h2m-4 1h2m-2 1h2m-4 1h2m-2 1h2m-4 1h2m-2 1h2m-4 1h2m-2 1h2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#582b2b",
    d: "M18 4h2m-2 1h2m-4 1h4m-4 1h4m-6 1h4m-4 1h4m-6 1h4m-4 1h4m-6 1h4m-4 1h4m-6 1h4m-4 1h4m-4 1h2m-2 1h2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#151517",
    d: "M18 8h2m-2 1h2m-4 1h2m-2 1h2m-4 1h2m-2 1h2m-4 1h2m-2 1h2m-4 1h2m-2 1h2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#986f1e",
    d: "M2 12h2m-2 1h2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "#99701e",
    d: "M4 14h2m-2 1h2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    stroke: "#77541a",
    d: "M4 16h2m-2 1h2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    stroke: "#483210",
    d: "M6 16h2m-2 1h2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    stroke: "#a43f35",
    d: "M2 18h2m-2 1h2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    stroke: "#3b290d",
    d: "M4 18h2m-2 1h2"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    stroke: "#22190a",
    d: "M6 18h2m-2 1h2"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    stroke: "#432f18",
    d: "M8 18h2m-2 1h2"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    stroke: "#7d3534",
    d: "M2 20h2m-2 1h2"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    stroke: "#512929",
    d: "M4 20h2m-2 1h2"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    stroke: "#201607",
    d: "M10 20h2m-2 1h2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.ee16c17c77fce082becce60e118cb4be.svg";
export { ForwardRef as ReactComponent };